// extracted by mini-css-extract-plugin
module.exports =  {"tooltipBackgroundColor":"#3c5063","mainBlue":"#0078d3","styleEnvironment":"geotab"};